import React from "react";
import { Formik } from "formik";
import "../../style/helper.css";
import axios from "axios";
import {Redirect} from "react-router-dom";
import ApiService from "../../Services/ApiService.js";

class Login extends React.Component {

    state = {
        isLoggedIn: false
    };

    componentDidMount() {
        this.setStateFromToken()
    }

    setStateFromToken = () => {
        const hasToken = sessionStorage.getItem("jwt") ? true : false;
        this.setState({
            isLoggedIn: hasToken
        })
    };

    handleSubmit = (values) => {
        localStorage.setItem( 'active', "clients" );
        ApiService.post('/api/login', values)
            .then(function(response) {
                sessionStorage.setItem("jwt", response.data.success.api_token);
                this.setStateFromToken()
            }.bind(this))
            .catch(function (error) {
                if (error) {
                    console.log("Post Error : " +error)
                }
            });
    };

    LoginForm = () => (
        <div className="login-modal">
          <div className="login-message">
            Welcome back! Please login to your account
          </div>
          <Formik
            initialValues={{ username: "", password: "" }}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                setSubmitting(false);
                this.handleSubmit(values)
              }, 500);
            }}
          >
            {props => {
              const {
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
                handleReset
              } = props;
              return (
                <form onSubmit={handleSubmit}>
                  <input
                    id="username"
                    placeholder="Username"
                    type="text"
                    value={values.username}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      errors.username && touched.username
                        ? "text-input error"
                        : "text-input"
                    }
                  />
                  {errors.username && touched.username && (
                    <div className="input-feedback">{errors.username}</div>
                  )}
                  <input
                    id="password"
                    placeholder="Password"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      errors.password && touched.password
                        ? "text-input error"
                        : "text-input"
                    }
                  />
                  <div className="remember-me">
                    <input
                      id="remember"
                      type="checkbox"
                      value={true}
                    /> 
                    <label>Remember me</label>
                  </div>
                  {errors.password && touched.password && (
                    <div className="input-feedback">{errors.password}</div>
                  )}
                  <div className="login-bottons">
                    <button type="submit" disabled={isSubmitting}>
                      Login
                    </button>
                    <button
                      type="button"
                      className="outline"
                      onClick={handleReset}
                      disabled={!dirty || isSubmitting}
                    >
                      Reset
                    </button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
    );

    render() {
        return(
            this.state.isLoggedIn
            ? <Redirect to="/clients"/>
            :this.LoginForm()     
        )
    }
}

export default Login;

